export default {"src":"/_next/static/media/express-shipping.28affe25.svg","height":28,"width":28};